import { render, staticRenderFns } from "./ImgTransOverlay.vue?vue&type=template&id=46fb013c&"
import script from "./ImgTransOverlay.vue?vue&type=script&lang=js&"
export * from "./ImgTransOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ImgTransOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports